import axios from "../lib/axios";

export const createGroups = async (data) => {
  try {
    const response = await axios.post("/groups/create", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getGroups = async () => {
  try {
    const response = await axios.get("/groups");
    return response.data;
  } catch (error) {
    console.log(error?.response?.data?.message || "Failed to create message");
  }
};

export const getGroupsOptions = async () => {
  try {
    const response = await axios.get("/groups/dropdown-options");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const deleteGroupData = async (groupId, userId) => {
  try {
    const response = await axios.delete(`/groups/${groupId}/users/${userId}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const updateGroupData = async (groupId, payload) => {
  try {
    const response = await axios.put(`/groups/update/${groupId}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const updateGroupDatDetails = async (groupId, payload) => {
  try {
    const response = await axios.put(
      `/groups/update-details/${groupId}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const deleteGroup = async (groupId) => {
  try {
    const response = await axios.delete(`/groups/${groupId}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const deleteGroupemail = async (groupId) => {
  try {
    const response = await axios.delete(`/groups/email/${groupId}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};
